/* eslint-disable no-nested-ternary */
// 9fbef606107a605d69c0edbcd8029e5d
import { css } from 'styled-components';

export const themeColor = (props, shade) => {
  switch (props?.theme?.brand) {
    case 'gym':
      return props.theme.colorPalette.orange[shade];
    case 'snj':
      return props.theme.colorPalette.purple[shade];
    default:
      return props.theme.colorPalette.blue[shade];
  }
};

const getOfferTextMarginTop = (props) => {
  let result = props.theme.spacing.ELEM_SPACING.MED_1;
  if (props.isCarouselIncluded || props.isBagPage) {
    result = 0;
  } else if (props.isMiniBag) {
    result = props.theme.spacing.ELEM_SPACING.XXXS;
  }
  return result;
};

const getOfferTextMarginTopMobile = (props) => {
  let result = props.theme.spacing.ELEM_SPACING.MED_1;
  if (props.isBagPage || props.isCarouselIncluded) {
    result = 0;
  } else if (props.isSinglePageCheckout) {
    result = '-3px';
  }
  return result;
};

const getRightPostion = (props) => {
  let result = 0;
  if (props.isMobileWebProductTile && !props.isSinglePageCheckout) {
    result = '-15px';
  } else if (props.isSinglePageCheckout) {
    result = '2px';
  }
  return result;
};

const getOfferModalWidth = (props) => {
  if (props.isCarouselIncluded) {
    return '250px';
  }
  if (props.isMobileWebProductTile || props.isSinglePageCheckout) {
    return '239px';
  }
  return '280px';
};

export const CartOfferToolTipStyles = css`
  ${(props) =>
    !props.isMobileWebProductTile && !props.isSinglePageCheckout && `position: relative;`}
  .offer-applied {
    text-decoration: underline;
    text-underline-offset: 3px;
    cursor: pointer;
    text-align: right;
    font-size: ${(props) => (props.isCarouselIncluded ? '' : props.isMiniBag ? '13px' : '14px')};
    margin-top: ${(props) => getOfferTextMarginTop(props)};
    line-height: ${(props) =>
      props.isBagPage
        ? props.theme.spacing.ELEM_SPACING.MED_1
        : props.theme.spacing.ELEM_SPACING.LRG};
    @media ${(props) => props.theme.mediaQuery.smallOnly} {
      font-size: ${(props) => props.theme.spacing.ELEM_SPACING.SM};
      font-weight: 600;
      margin-top: ${(props) => getOfferTextMarginTopMobile(props)};
    }
  }
  .offer-applied img {
    display: inline;
  }
  .promotion-label-container {
    position: absolute;
    right: ${(props) => props.theme.spacing.ELEM_SPACING.XS_1};
    bottom: ${(props) => props.theme.spacing.ELEM_SPACING.XS_1};
  }
  .promotions-head {
    padding-bottom: 9px;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .inner-offer-applied {
    color: ${(props) => {
      switch (props?.theme?.brand) {
        case 'gym':
          return props.theme.colorPalette.orange[900];
        case 'snj':
          return props.theme.colorPalette.purple[900];
        default:
          return props.theme.colorPalette.blue[800];
      }
    }};
  }
  .close-icon-image-tooltip {
    height: ${(props) => props.theme.spacing.ELEM_SPACING.MED_2};
    width: ${(props) => props.theme.spacing.ELEM_SPACING.MED_2};
    cursor: pointer;
  }
  .separator-top {
    padding-top: 9px;
    margin-bottom: ${(props) => props.theme.spacing.ELEM_SPACING.XXS};
    border-top: 1px solid ${(props) => themeColor(props, 100)};
  }
  .list-container {
    border-top: 1px solid ${(props) => themeColor(props, 100)};
    margin-left: 18px;
  }
  .discount-toolTip {
    color: ${(props) => props.theme.colorPalette.red[500]};
    white-space: nowrap;
  }
  .no-of-coupons-applied {
    display: flex;
    align-items: center;
  }
  .promotions-applied {
    display: flex;
    justify-content: space-between;
  }
  .total-tool-tip {
    display: flex;
    justify-content: space-between;
    margin-left: 18px;
  }
  .promotion-text {
    color: ${(props) => props.theme.colorPalette.gray[900]};
    list-style: disc;
  }
  .tooltip-content {
    width: 302px;
    position: ${(props) => (props.isCarouselIncluded ? 'relative' : 'absolute')};
    right: ${(props) => getRightPostion(props)};
    border: 1px solid ${(props) => themeColor(props, 100)};
    background: #fff;
    padding: 14px;
    box-sizing: border-box;
    border-radius: 6px;
    z-index: 10;
    box-shadow: 0px 5px 15px rgba(107, 107, 107, 0.15);
    @media ${(props) => props.theme.mediaQuery.smallOnly} {
      width: ${(props) => getOfferModalWidth(props)};
    }
  }
  &.from-productinfomtaion {
    .offer-applied {
      font-size: 11px;
    }
    .icon-offer-carot img {
      height: 5px !important;
      display: inline;
    }
    .tooltip-content {
      width: 250px;
    }
  }

  .icon-offer-carot {
    margin-left: 5px;
    transform: rotate(0deg);
    transition: transform 0.25s linear;
    height: ${(props) => (props.isCarouselIncluded ? 'auto' : '5px')};
    &.open {
      transform: rotate(180deg);
    }
  }
  .order-level-promotion {
    margin-left: 19px;
  }
  .cart-offer-tool-tip {
    display: flex;
  }
`;

export default CartOfferToolTipStyles;
